function parseQuery (q, body = { view_source: 'aalive7' }) {
  const stepZero = customSubstitution(q, body)

  if (Array.isArray(stepZero)) {
    if (stepZero.length === 1) {
      if (typeof stepZero[0] === 'object' && !Array.isArray(stepZero[0])) {
        return { bool: { must: [tokenToTerm(stepZero[0])] } }
      }
    }
  }
  const stepOne = prefix(stepZero)
  return parser(stepOne)
}

function customSubstitution (target, body) {
  const newTarget = []
  for (const current of target) {
    if (typeof current === 'object' && !Array.isArray(current)) {
      if (current.hasOwnProperty('type')) {
        if (current.type === 'custom') {
          if (current.query.length === 1) newTarget.push(current.query[0])
          else newTarget.push(current.query)
        } else if (current.id === 'liteviewer' && current.dataset === 'shortcuts') {
          if (body.hasOwnProperty('view_source')) current.id = `liteviewer_${body.view_source}`
          else current.id = 'liteviewer_aalivesd'
          newTarget.push(current)
        } else newTarget.push(current)
      } else newTarget.push(current)
    } else if (Array.isArray(current)) newTarget.push(customSubstitution(current, body))
    else newTarget.push(current)
  }
  return newTarget
}

function prefix (target) {
  if (typeof target === 'object' && !Array.isArray(target)) return target

  let i = target.length - 1
  const output = []          // queue
  const operators = []

  while (i >= 0) {
    const current = target[i]
    if (['number', 'object'].includes(typeof current) && !Array.isArray(current)) output.push(current)
    if (typeof current === 'string') {
      let flag = true
      while (flag) {
        if (operators.length > 0) {
          const top = operators[0]
          if (compareTo(top, current)) {
            output.push(top)
            operators.shift()
          } else flag = false
        } else flag = false
      }
      operators.unshift(current)  // push the read operator onto the operator stack.
    }
    if (Array.isArray(current)) output.push(prefix(current))
    i -= 1
  }
  let j = 0
  while (j < operators.length) {
    output.push(operators[j])
    j += 1
  }
  const newOutput = []
  while (output.length > 0) newOutput.unshift(output.shift())
  return newOutput
}

function compareTo (opt1, opt2) {
  const code = ['MIN', 'OR', 'AND', 'NOT']
  return code.indexOf(opt1) > code.indexOf(opt2)
}

function parser (target) {
  let response = {}
  if (target.length === 0) return response

  Object.assign(response, { bool: { should: [], must: [], must_not: [] } })

  if (Array.isArray(target)) {
    if (target) {
      const current = target.shift()
      if (typeof current === 'string') {
        const LHS = parser(target)
        const RHS = parser(target)

        // OR
        if (current === 'OR') {
          if (LHS.hasOwnProperty('bool')) {
            if (LHS.bool.hasOwnProperty('should')) {
              if (LHS.bool.hasOwnProperty('minimum_should_match')) response.bool.should.push(LHS)
              else response.bool.should.push(...LHS.bool.should)
            } else response.bool.should.push(LHS)
          } else response.bool.should.push(LHS)

          if (RHS.hasOwnProperty('bool')) {
            if (RHS.bool.hasOwnProperty('should')) {
              if (RHS.bool.hasOwnProperty('minimum_should_match')) response.bool.should.push(RHS)
              else response.bool.should.push(...RHS.bool.should)
            } else response.bool.should.push(RHS)
          } else if (RHS) response.bool.should.push(RHS)
        } else if (current === 'AND') {
          if (LHS.hasOwnProperty('bool')) {
            if (LHS.bool.hasOwnProperty('must')) {
              if (LHS.bool.hasOwnProperty('minimum_should_match')) response.bool.must.push(LHS)
              else response.bool.must.push(...LHS.bool.must)
            }
            if (LHS.bool.hasOwnProperty('must_not')) response.bool.must_not.push(...LHS.bool.must_not)
            else response.bool.must.push(LHS)
          } else response.bool.must.push(LHS)

          if (RHS.hasOwnProperty('bool')) {
            if (RHS.bool.hasOwnProperty('must')) {
              if (RHS.bool.hasOwnProperty('minimum_should_match')) response.bool.must.push(RHS)
              else response.bool.must.push(...RHS.bool.must)
            }
            if (RHS.bool.hasOwnProperty('must_not')) response.bool.must_not.push(...RHS.bool.must_not)
            else response.bool.must.push(RHS)
          } else response.bool.must.push(RHS)
        } else if (current === 'NOT') {
          if (LHS.hasOwnProperty('bool')) {
            if (LHS.bool.hasOwnProperty('must')) response.bool.must.push(...LHS.bool.must)
            if (LHS.bool.hasOwnProperty('must_not')) response.bool.must_not.push(...LHS.bool.must_not)
            if (LHS.bool.hasOwnProperty('should')) response.bool.should.push(...LHS.bool.should)
            if (LHS.bool.hasOwnProperty('minimum_should_match')) response.bool.minimum_should_match = LHS.bool.minimum_should_match
          } else {
            response.bool.must.push(LHS)
          }

          if (RHS.hasOwnProperty('bool')) {
            if (RHS.bool.hasOwnProperty('must_not')) response.bool.must_not.push(...RHS.bool.must_not)
            else if (RHS) response.bool.must_not.push(RHS)
          } else if (RHS) response.bool.must_not.push(RHS)
        } else if (current === 'MIN') {
          if (typeof LHS === 'number') {
            if (RHS.hasOwnProperty('bool')) {
              RHS.bool.minimum_should_match = LHS
              if (RHS.bool.hasOwnProperty('should')) response.bool.should = RHS.bool.should
              if (RHS.bool.hasOwnProperty('must')) response.bool.must = RHS.bool.must
              if (RHS.bool.hasOwnProperty('must_not')) response.bool.must_not = RHS.bool.must_not
              if (RHS.bool.hasOwnProperty('minimum_should_match')) response.bool.minimum_should_match = RHS.bool.minimum_should_match
            } else response = RHS
          } else if (typeof RHS === 'number') {
            if (LHS.hasOwnProperty('bool')) {
              LHS.bool.minimum_should_match = RHS
              if (LHS.bool.hasOwnProperty('should')) response.bool.should = LHS.bool.should
              if (LHS.bool.hasOwnProperty('must')) response.bool.must = LHS.bool.must
              if (LHS.bool.hasOwnProperty('must_not')) response.bool.must_not = LHS.bool.must_not
              if (LHS.bool.hasOwnProperty('minimum_should_match')) response.bool.minimum_should_match = LHS.bool.minimum_should_match
            } else {
              response = LHS
              response.minimum_should_match = RHS
            }
          }
        } else console.error('BAD TOKEN!')
      }
      if (Array.isArray(current)) return parser(current)
      if (typeof current === 'object' && !Array.isArray(current)) return tokenToTerm(current)
      if (typeof current === 'number') return current
    }
  }
  if (response.hasOwnProperty('bool')) {
    if (response.bool.hasOwnProperty('should') && response.bool.should.length === 0) delete response.bool.should
    if (response.bool.hasOwnProperty('must') && response.bool.must.length === 0) delete response.bool.must
    if (response.bool.hasOwnProperty('must_not') && response.bool.must_not.length === 0) delete response.bool.must_not
  }
  return response
}

function tokenToTerm (token) {
  let term = {}
  const attribPath = `${token.dataset}.${token.id}`
  if (typeof token.value === 'object' && !Array.isArray(token.value)) {
    const rangeValue = token.value
    const regex = /(\d{4})-(\d{2})-(\d{2})/

    if (rangeValue.hasOwnProperty('min')) {
      const match = regex.exec(rangeValue.min.toString())
      if (match) rangeValue.min = [match[1], match[2], match[3]].join('')
    }
    if (rangeValue.hasOwnProperty('max')) {
      const match = regex.exec(rangeValue.max.toString())
      if (match) rangeValue.max = [match[1], match[2], match[3]].join('')
    }
    if (rangeValue.hasOwnProperty('min') && rangeValue.hasOwnProperty('max')) {
      term = {
        range: {
          [attribPath]: { gte: rangeValue.min, lte: rangeValue.max }
        }
      }
    } else if (rangeValue.hasOwnProperty('min')) term = { range: { [attribPath]: { gte: rangeValue.min } } }
    else if (rangeValue.hasOwnProperty('max')) term = { range: { [attribPath]: { lte: rangeValue.max } } }
  } else {
    if (token.value === true) {
      const datasetAttr = `${token.dataset}.${token.dataset}_yes`
      term = { term: { [datasetAttr]: token.id } }
    } else if (token.value === false) {
      const datasetAttr = `${token.dataset}.${token.dataset}_no`
      term = { term: { [datasetAttr]: token.id } }
    } else term = { term: { [attribPath]: token.value } }
  }
  return term
}

export function handleEmptyQuery (startDate, endDate) {
  return {
    bool: {
      must: {
        range: {
          broadcastdate: { gte: startDate, lte: endDate }
        }
      }
    }
  }
}

function getEsQuery (q = [], body = { view_source: 'aalive7' }) {
  const startDate = body['start-date']
  const endDate = body['end-date']
  const esSearch = { size: 0 }
  if (q.length === 0) esSearch.query = handleEmptyQuery(startDate, endDate)
  else {
    const finalQuery = parseQuery(q, body)
    if (finalQuery.hasOwnProperty('bool') && !finalQuery.bool.hasOwnProperty('minimum_should_match')) {
      finalQuery.bool.minimum_should_match = '0<1'
    }
    finalQuery.bool.filter = {
      bool: {
        must: [
          {
            range: {
              broadcastdate: { gte: startDate, lte: endDate, format: 'yyyy-MM-dd' }
            }
          },
          {
            range: {
              'respondent.age': { gte: 18 }
            }
          }
        ]
      }
    }
    esSearch.query = finalQuery
  }
  return esSearch
}

function getDataSources (query = []) {
  return new Set(query.flat(Infinity).filter(n => n.dataset).map(n => n.dataset))
}

export {getDataSources}

export default getEsQuery



// WEBPACK FOOTER //
// ./src/app/api/elasticsearch/esParser.js